// src/security/usePermissao.js
import { useCallback, useContext, useMemo } from 'react';
import AuthContext from '../context/AuthContext';
import { useBootstrap } from '../context/BootstrapContext';
import { avaliarCapacidade, PLANO_PADRAO } from './capacidades';
import { papeisDoToken } from './papeis';

/**
 * Pergunta à matriz de capacidades se o usuário logado pode algo.
 *
 *   const { pode } = usePermissao();
 *   if (!pode('dados.alterar')) return;
 *
 * Sem bootstrap (ainda carregando ou falha de leitura) o plano é BASIC: na
 * dúvida, o menor conjunto de recursos.
 */
export function usePermissao() {
    const { user } = useContext(AuthContext);
    const { bootstrap } = useBootstrap();

    const papeis = useMemo(() => papeisDoToken(user), [user]);
    const plano = String(bootstrap?.plan || PLANO_PADRAO).toUpperCase();

    const pode = useCallback(
        (chave) => avaliarCapacidade(chave, { plano, papeis }),
        [plano, papeis]
    );

    return { pode, plano, papeis };
}
